import { required, useNotify, useRedirect } from "ra-core";
import { Create } from "@/components/admin/create";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { SimpleForm } from "@/components/admin/simple-form";
import { TextInput } from "@/components/admin/text-input";
import { BulkDeleteButton } from "@/components/admin/bulk-delete-button";
import { MobilePage } from "../MobilePage";
import { useIsDueno } from "../useIsDueno";
import { dncAdd } from "./dncRpc";

const KINDS = [
  { id: "phone", name: "Teléfono" },
  { id: "email", name: "Correo" },
];
const REASONS = [
  { id: "repep", name: "REPEP" },
  { id: "arco", name: "Solicitud ARCO" },
  { id: "baja", name: "Pidió baja" },
  { id: "rebote", name: "Rebote" },
  { id: "numero_incorrecto", name: "Número incorrecto" },
];

export const DoNotContactList = () => {
  const isDueno = useIsDueno();
  if (!isDueno) {
    return (
      <MobilePage title="No contactar">
        <p className="text-sm text-muted-foreground">
          La lista la administra el dueño.
        </p>
      </MobilePage>
    );
  }
  return (
    <MobilePage title="No contactar">
      <List
        title="No contactar"
        filters={[
          <SearchInput
            key="q"
            source="value@ilike"
            placeholder="Buscar"
            alwaysOn
          />,
        ]}
        exporter={false}
        sort={{ field: "created_at", order: "DESC" }}
        perPage={50}
        disableBreadcrumb
        actions={<CreateButton label="Agregar" />}
      >
        <p className="text-sm text-muted-foreground mb-2">
          Nadie de esta lista puede recibir llamadas, WhatsApp ni correos desde
          el CRM. "Pidió baja" y "Número incorrecto" los agregan solos.
        </p>
        <DataTable
          rowClick={false}
          bulkActionButtons={<BulkDeleteButton label="Quitar de la lista" />}
        >
          <DataTable.Col label="Teléfono o correo" source="value" />
          <DataTable.Col
            label="Tipo"
            source="kind"
            render={(r) => KINDS.find((k) => k.id === r.kind)?.name}
          />
          <DataTable.Col
            label="Motivo"
            source="reason"
            render={(r) =>
              REASONS.find((k) => k.id === r.reason)?.name ?? r.reason
            }
          />
          <DataTable.Col label="Desde" source="created_at">
            <DateField source="created_at" />
          </DataTable.Col>
        </DataTable>
      </List>
    </MobilePage>
  );
};

export const DoNotContactCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSubmit = async (values: Record<string, unknown>) => {
    try {
      const isNew = await dncAdd(
        String(values.value ?? ""),
        String(values.kind),
        String(values.reason),
      );
      if (!isNew) {
        notify("Ese número o correo ya estaba en la lista.", {
          type: "warning",
        });
        return;
      }
      notify("Agregado a No contactar.", { type: "success" });
      redirect("list", "do_not_contact");
    } catch (e) {
      notify(
        `No se pudo agregar: ${e instanceof Error ? e.message : "revisa el dato e inténtalo de nuevo"}`,
        { type: "error" },
      );
    }
  };
  return (
    <MobilePage title="Agregar a no contactar">
      <Create title="Agregar a no contactar" redirect="list">
        <SimpleForm onSubmit={onSubmit}>
          <SelectInput
            source="kind"
            label="Tipo"
            choices={KINDS}
            defaultValue="phone"
            validate={required()}
          />
          <TextInput
            source="value"
            label="Teléfono (10 dígitos) o correo"
            validate={required()}
          />
          <SelectInput
            source="reason"
            label="Motivo"
            choices={REASONS}
            defaultValue="repep"
            validate={required()}
          />
        </SimpleForm>
      </Create>
    </MobilePage>
  );
};
